/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { seguridad } from '../../conexiones';
import ITipoIdentificacion from './entidades/tipoIdentificacion';

export default class ModeloTipoIdentificacion {
    public consultarTipoIdentificacion() {
        return manejadorRest<IRespuesta<ITipoIdentificacion>>(() =>
          seguridad.get('TipoIdentificacion/ConsultarListaTipoIdentificacion')
        );
    }
    public crearTipoIdentificacion(tipoIdentificacion: ITipoIdentificacion) {
        return manejadorRest<IRespuesta<ITipoIdentificacion>>(() =>
            seguridad.post('TipoIdentificacion/GuardarTipoIdentificacion', tipoIdentificacion)
        );
    }
    public editarTipoIdentificacion(tipoIdentificacion: ITipoIdentificacion) {
        return manejadorRest<IRespuesta<ITipoIdentificacion>>(() =>
            seguridad.put('TipoIdentificacion/EditarTipoIdentificacion', tipoIdentificacion)
        );
    }
    public eliminarTipoIdentificacion(tipoIdentificacion: ITipoIdentificacion) {
        return manejadorRest<IRespuesta<ITipoIdentificacion>>(() =>
            seguridad.delete('TipoIdentificacion/EliminarTipoIdentificacion', tipoIdentificacion)
        );
    }
}
